// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar__container___2FOFj","content":"sidebar__content___2JoUk"};